import z from "zod";
import {
  ProductGroupIdScheme,
  PrepStationIdScheme,
  CourseIdScheme,
  ModifierGroupIdScheme,
  ModifierIdScheme,
  UnitIdScheme,
  BookkeepingAccountIdScheme,
} from "./ids";
import { ProductType } from "./enums/ProductType";
import { VariantSelectionMode } from "./enums/VariantSelectionMode";
import { CatalogOrigin } from "./enums/CatalogOrigin";

export const ProductGroupDBScheme = z.object({
  id: ProductGroupIdScheme,
  name: z.string(),
  VAT: z.number().nullable(),
  type: z.enum(ProductType).nullable(),
  prepStationId: PrepStationIdScheme.optional().nullable(),
  courseId: CourseIdScheme.optional().nullable(),
  modifiers: z.array(ModifierIdScheme).optional().nullable(),
  modifierGroups: z.array(ModifierGroupIdScheme).optional().nullable(),
  alwaysAppliedModifiers: z.array(ModifierIdScheme).optional().nullable(),
  unitId: UnitIdScheme.nullable(),
  bookkeepingAccountId: BookkeepingAccountIdScheme.optional().nullable(),
  takeawayVAT: z.number().optional().nullable(),
  takeawayBookkeepingAccountId:
    BookkeepingAccountIdScheme.optional().nullable(),
  variantSelectionMode: z.enum(VariantSelectionMode).optional(),
  includeMainProductAsVariant: z.boolean().optional(),
  productSyncEnabled: z.boolean().nullable().optional(),
  noDiscount: z.boolean().optional(),
  origin: z.enum(CatalogOrigin).optional(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export const RestGetProductGroup = ProductGroupDBScheme;

export const RestCreateProductGroup = ProductGroupDBScheme.omit({
  id: true,
  updatedAt: true,
  createdAt: true,
});

export const RestUpdateProductGroup = ProductGroupDBScheme.omit({
  id: true,
  updatedAt: true,
  createdAt: true,
}).partial();

export type DBProductGroup = z.infer<typeof ProductGroupDBScheme>;
export type RestProductGroup = z.infer<typeof RestGetProductGroup>;
export type RestCreateProductGroup = z.infer<typeof RestCreateProductGroup>;
export type RestUpdateProductGroup = z.infer<typeof RestUpdateProductGroup>;
